import React from 'react';
import { BentoGrid } from './components/BentoGrid';
export function App() {
  return <div className="w-full bg-white text-slate-900 font-sans" data-id="element-0">
      <BentoGrid data-id="element-1" />
    </div>;
}